import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 py-12 border-t border-navy-border text-center" data-id="element-71">
      <div className="max-w-6xl mx-auto px-4" data-id="element-72">
        <p className="text-accent font-serif italic text-xl mb-4" data-id="element-73">
          Vínculos de Hierro
        </p>
        <p className="text-muted text-sm mb-8" data-id="element-74">
          Manual de Transformación Consciente para la Pareja Moderna
        </p>

        <div className="flex justify-center gap-6 text-sm text-muted mb-8" data-id="element-75">
          <a href="#" className="hover:text-accent transition-colors" data-id="element-76">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-accent transition-colors" data-id="element-77">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-accent transition-colors" data-id="element-78">
            Contacto
          </a>
        </div>

        <p className="text-xs text-navy-border/50" data-id="element-79">
          © {new Date().getFullYear()} Vínculos de Hierro. Todos los derechos
          reservados.
        </p>
        <p className="text-xs text-navy-border/30 mt-2 max-w-2xl mx-auto" data-id="element-80">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}